import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
    interface Window {
        gtag: (...args: any[]) => void;
    }
}

const GoogleAnalytics: React.FC = () => {
    const location = useLocation();
    const trackingId = process.env.REACT_APP_GA_TRACKING_ID;

    useEffect(() => {
        if (!trackingId) return;

        // Initialize Google Analytics
        const script1 = document.createElement('script');
        script1.async = true;
        script1.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
        document.head.appendChild(script1);

        const script2 = document.createElement('script');
        script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${trackingId}');
    `;
        document.head.appendChild(script2);

        return () => {
            document.head.removeChild(script1);
            document.head.removeChild(script2);
        };
    }, [trackingId]);

    useEffect(() => {
        if (!trackingId || !window.gtag) return;

        // Track page views
        window.gtag('config', trackingId, {
            page_path: location.pathname + location.search,
        });
    }, [location, trackingId]);

    return null;
};

export default GoogleAnalytics;
